export const downloadFile = (url: string, method: "get" | "post" = "get", values: { [key: string]: string }): void => {
  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("target", "_blank");
  form.setAttribute("rel", "noopener noreferrer");
  form.setAttribute("action", url);

  if (values) {
    Object.keys(values).forEach((name) => {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", name);
      input.setAttribute("value", values[name]);
      form.appendChild(input);
    });
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;

  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      anchor.removeEventListener("click", clickHandler);
    }, 150);
  };
  anchor.addEventListener("click", clickHandler, false);
  anchor.click();
};
